import React, { forwardRef, memo, useRef } from "react";
import { CondensedTypographyMedium } from "fe-web-components/styles/typography";
import Button from "@mui/material/Button";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { List, ListItem, ListItemIcon, styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import ListItemText from "@mui/material/ListItemText";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useShareLinks } from "../../saveCase/useShareLinks";

const ShareButton = styled(Button)({
  "&:hover": {
    color: KahunColorMap.Accent,
  },
  cursor: "pointer",
});

const SharePopUpContainer = styled("div")(() => ({
  background: KahunColorMap.Background,
  width: "300px",
  height: "400px",
  border: "2px solid",
  display: "flex",
  flexDirection: "column",
}));

const CloseButton = styled(Button)({
  alignSelf: "center",
});

const ShareText = styled(CondensedTypographyMedium)({
  cursor: "default",
});

const PatientCaseShare = forwardRef(
  ({ shareId, onClose }: { shareId: string; onClose: () => void }, ref) => {
    const textAreaRef = useRef(null);
    const explorerTextAreaRef = useRef(null);

    const copyToClipboard = (ref) => {
      ref.current.select();
      document.execCommand("copy");
      ref.current.blur();
    };

    const { shareLink, explorerShareLink } = useShareLinks();

    const openExplorer = (id) => {
      window.open(explorerShareLink(id), "_blank");
    };

    if (!shareId) return null;

    return (
      <SharePopUpContainer>
        <textarea
          ref={textAreaRef}
          style={{ zIndex: -1000, position: "absolute" }}
          value={shareLink(shareId)}
          readOnly
        />
        <textarea
          ref={explorerTextAreaRef}
          style={{ zIndex: -1000, position: "absolute" }}
          value={explorerShareLink(shareId)}
          readOnly
        />
        <List>
          <ListItem>
            <ListItemText primary={<ShareText>Copy to Clipboard</ShareText>} />
            <ListItemIcon>
              <ShareButton onClick={() => copyToClipboard(textAreaRef)}>
                <AssignmentIcon />
              </ShareButton>
            </ListItemIcon>
          </ListItem>
          <ListItem>
            <ListItemText primary={<ShareText>Copy Explorer Link</ShareText>} />
            <ListItemIcon>
              <ShareButton onClick={() => copyToClipboard(explorerTextAreaRef)}>
                <AssignmentIcon />
              </ShareButton>
            </ListItemIcon>
          </ListItem>
          <ListItem>
            <ListItemText
              primary={<ShareText>Open as Explorer Case</ShareText>}
            />
            <ListItemIcon>
              <ShareButton onClick={() => openExplorer(shareId)}>
                <OpenInNewIcon />
              </ShareButton>
            </ListItemIcon>
          </ListItem>
        </List>
        <CloseButton variant="outlined" color="primary" onClick={onClose}>
          Close
        </CloseButton>
      </SharePopUpContainer>
    );
  },
);

export default memo(PatientCaseShare);
